export function fmtDate(iso: string | null | undefined): string {
  if (!iso) return '–';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString('de-AT', { day: '2-digit', month: '2-digit', year: 'numeric' });
}
export function fmtDateTime(iso: string | null | undefined): string {
  if (!iso) return '–';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString('de-AT', {
    day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
  });
}
export function fmtEuro(n: number): string {
  return new Intl.NumberFormat('de-AT', {
    style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0,
  }).format(n);
}
export function alter(iso: string | null | undefined): number | null {
  if (!iso) return null;
  const d = new Date(iso);
  const t = new Date();
  let a = t.getFullYear() - d.getFullYear();
  const m = t.getMonth() - d.getMonth();
  if (m < 0 || (m === 0 && t.getDate() < d.getDate())) a--;
  return a;
}
export function initials(vor: string | null | undefined, nach: string | null | undefined): string {
  return ((vor?.[0] ?? '') + (nach?.[0] ?? '')).toUpperCase();
}
export function relativeTime(iso: string): string {
  const d = new Date(iso); const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return 'gerade eben';
  if (diff < 3600) return `vor ${Math.floor(diff / 60)} Min`;
  if (diff < 86400) return `vor ${Math.floor(diff / 3600)} Std`;
  if (diff < 2 * 86400) return 'gestern';
  if (diff < 7 * 86400) return `vor ${Math.floor(diff / 86400)} Tagen`;
  return d.toLocaleDateString('de-AT', { day: '2-digit', month: 'short' });
}

export const MITGLIEDSART_LABEL: Record<string, string> = {
  aktiv: 'aktiv',
  unterstuetzend: 'unterstützend',
  jugend: 'Jugend',
  ehrenmitglied: 'Ehrenmitglied',
};

export const MITGLIEDSART_INFO: Record<string, string> = {
  aktiv: 'Ist in der jeweiligen Sektion sportlich aktiv und bezahlt den von der Sektion festgelegten Mitgliedsbeitrag.',
  jugend: 'Ist unter 18 Jahre alt und in der jeweiligen Sektion sportlich aktiv (und bezahlt den festgelegten Mitgliedsbeitrag).',
  unterstuetzend: 'Ist in der jeweiligen Sektion nicht sportlich aktiv, unterstützt diese jedoch durch die Zahlung eines Mitgliedsbeitrags.',
  ehrenmitglied: 'Ist in der jeweiligen Sektion nicht sportlich aktiv und bezahlt auch keinen Mitgliedsbeitrag.',
};

/**
 * Ermittelt die automatische Mitgliedsart basierend auf Geburtsdatum:
 * - Person unter 18 → 'jugend' (erzwungen)
 * - Sonst wird der aktuelle Wert beibehalten
 */
export function autoMitgliedsart(geburtsdatum: string | null | undefined, current: string): string {
  const age = alter(geburtsdatum);
  if (age !== null && age < 18) return 'jugend';
  return current;
}

export function isUnder18(geburtsdatum: string | null | undefined): boolean {
  const age = alter(geburtsdatum);
  return age !== null && age < 18;
}
export const MEMBER_STATUS_LABEL: Record<string, string> = {
  aktiv: 'aktiv',
  ausgetreten: 'ausgetreten',
  verstorben: 'verstorben',
};
export const MEMBERSHIP_STATUS_LABEL: Record<string, string> = {
  mitglied: 'Mitglied',
  aktiv: 'aktiv',
  funktionaer: 'Funktionär',
  ruhend: 'ruhend',
  ausgetreten: 'ausgetreten',
};
export const ROLE_LABEL: Record<string, string> = {
  admin: 'Admin',
  sektionsleiter: 'Sektionsleiter',
  stellvertreter: 'Stellvertreter',
  read_only: 'Read-Only',
};
export const USER_STATUS_TONE: Record<string, 'success' | 'warning' | 'neutral'> = {
  aktiv: 'success',
  eingeladen: 'warning',
  deaktiviert: 'neutral',
};
export const AUDIT_ACTION_META: Record<string, { label: string; icon: string; tone: 'success' | 'warning' | 'danger' | 'info' | 'neutral' }> = {
  create: { label: 'Anlegen', icon: 'plus', tone: 'success' },
  update: { label: 'Änderung', icon: 'pencil', tone: 'info' },
  delete: { label: 'Löschen', icon: 'trash-2', tone: 'danger' },
  export: { label: 'Export', icon: 'download', tone: 'info' },
  login_success: { label: 'Login', icon: 'log-in', tone: 'neutral' },
  login_failed: { label: 'Login fehlgeschlagen', icon: 'shield-alert', tone: 'warning' },
  password_changed: { label: 'Passwort geändert', icon: 'key-round', tone: 'info' },
  password_reset: { label: 'Passwort-Reset', icon: 'key-round', tone: 'warning' },
  recovery_used: { label: 'Recovery-Code', icon: 'life-buoy', tone: 'warning' },
  codes_regenerated: { label: 'Codes erneuert', icon: 'refresh-cw', tone: 'info' },
  master_token_used: { label: 'Notfall-Schlüssel', icon: 'siren', tone: 'danger' },
};

export function memberStatus(m: { status: string }): 'aktiv' | 'ausgetreten' | 'verstorben' {
  if (m.status === 'ausgetreten' || m.status === 'verstorben') return m.status;
  return 'aktiv';
}
